var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSledding = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.187 3a2.062 2.062 0 1 1 0 4.125 2.062 2.062 0 0 1 0-4.125zM7.5 8.156c0-.571.46-1.031 1.03-1.031h7.28c1.53 0 2.298 1.852 1.215 2.934l-2.913 2.91h2.669c.95 0 1.718.768 1.718 1.718v3.437c0 .331-.159.628-.404.817l1.887.98c.584.304 1.28.309 1.873.012l.653-.326a1.033 1.033 0 0 1 1.384.46c.253.506.047 1.13-.46 1.383l-.653.327a4.128 4.128 0 0 1-3.747-.03L2.554 13.195a1.031 1.031 0 1 1 .954-1.83l5.332 2.767a1.349 1.349 0 0 1 .378-1.508l3.897-3.438H8.531c-.572 0-1.031-.46-1.031-1.031zm8.937 6.875h-5.874l5.874 3.05v-3.05z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSledding, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-sledding.0d407321.svg";
export { ForwardRef as ReactComponent };